import { NavLink } from 'react-router-dom';
import { Task, Widget, WidgetProps } from '@/components';
import { useTranslation } from 'react-i18next';
import empty from '@/assets/images/empty-tasks.svg';
import { TaskPublicDtoRead } from '@/store/services/MidleNestApi.service';
import EmptyTasks from '@/assets/images/EmptyTasks';

interface QuestListProps extends WidgetProps {
  link?: string;
  showViewAll?: boolean;
  showStatusFilters?: boolean;
  showOtherFilters?: boolean;
  showPages?: boolean;
  tasks?: TaskPublicDtoRead[] | null;
  completedTasks?: string[];
  currentPage?: number;
  setCurrentPage?: (page: number) => void;
  totalPage?: number;
  splitQuests?: boolean;
}

export default function TaskList({
  link = '/tasks',
  tasks = [],
  className,
  ...props
}: QuestListProps) {
  const { t } = useTranslation();
  // console.log({ tasks });
  return (
    <Widget
      {...props}
      className={`min-h-full space-y-2 flex-1 flex flex-col ${className}`}
      actions={
        <div className='flex space-x-4'>
          <div className='w-full block'>
            <NavLink
              className='text-blue-500 dark:text-[#FFDA68] font-medium text-sm flex items-center'
              to={link}
            >
              {t('View All')}
              <i className='icon-right-open-big mt-0.5 ml-1' />
            </NavLink>
          </div>
        </div>
      }
    >
      {!tasks?.length ? (
        <div className='flex-1 h-full flex flex-col items-center justify-center text-gray-300 text-center'>
          {/* <img src={empty} alt={t('no tasks') || ''} className='object-contain' /> */}
          <EmptyTasks />
          <div className='text-black dark:text-white text-sm mt-4'>
            {t('You have completed all the tasks')}
          </div>
          <div className='text-black/60 dark:text-white/60 text-sm'>
            {t('New tasks will be coming soon...')}
          </div>
        </div>
      ) : (
        <div className='divide-y dark:divide-[#655A38] space-y-2'>
          {tasks?.map((task, idx) => (
            <Task
              customId={`${props.title?.toString() || ''}-${idx.toString()}`}
              key={task.id}
              {...task}
              className='pt-2 first:pt-0'
            />
          ))}
        </div>
      )}
    </Widget>
  );
}
